export interface ProductChange {
	Id: number | null;
	InitialProductSizeId: number | null;
	InitialProductSizeName: string | null;
	FinalProductSizeId: number | null;
	FinalProductSizeName: string | null;
	GoalTime: number | null;
	HistoryQuantity: number | null;
	HistoryTime: number | null;
}

export const PRODUCT_CHANGE_INITIAL_VALUES: ProductChange = {
	Id: null,
	InitialProductSizeId: null,
	InitialProductSizeName: null,
	FinalProductSizeId: null,
	FinalProductSizeName: null,
	GoalTime: null,
	HistoryQuantity: null,
	HistoryTime: null,
};

export interface ProductSizeOption {
	Id: number;
	Name: string;
}

export interface RecalculateResult {
	AverageChangeTime: number | null;
	NumberOfChanges: number | null;
}
